import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagementService } from '../../services/user-management.service';
import { AuthService } from '../../services/auth.service';
import { NotificationComponent } from '../notification/notification.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  userName?: string;
  userEmail?: string;
  userRole?: string;
  firstName?: string;

  @ViewChild(NotificationComponent) notificationComponent!: NotificationComponent;

  constructor(
    private userManagementService: UserManagementService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.userName = this.userManagementService.getName();
    this.userEmail = this.userManagementService.getEmail();
    this.userRole = this.userManagementService.getUserRole();
    this.firstName = this.userName?.split(' ')[0];
  }

  isDropdownOpen = false;

  isNotificationOpen = false;

  onNotificationVisibleChange(visible: boolean): void {
    if (visible) {
      this.notificationComponent?.getNotifications();
    }
  }

  dropdownToggle(visible: boolean): void {
    this.isDropdownOpen = visible;
  }

  signOut() {
    this.authService.logout();
  }
}
